import React from "react";

// Components
import PostCard, { PostCardInfo } from "./PostCard";
import { Link } from "gatsby";

// Styles
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";

const styles = createStyles({
  list: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    listStyle: "none",
  },
  post: {
    flex: "0 1 360px" /*  No stretching: */,
    margin: 16,
    maxHeight: 500,
  },
  link: {
    textDecoration: "none",
  },
});

export type PostListProps = {
  posts: ReadonlyArray<{ node: PostCardInfo }>;
} & WithStyles<typeof styles> &
  React.HTMLProps<HTMLElement>;

function PostList({
  posts,
  classes,
  ...sectionProps
}: PostListProps): JSX.Element {
  return (
    <section {...sectionProps}>
      <ul className={classes.list}>
        {posts.map((p) => (
          <li className={classes.post} key={p.node.frontmatter.path}>
            <Link
              to={p.node.frontmatter.path}
              aria-label={p.node.frontmatter.title}
              className={classes.link}
            >
              <PostCard {...p.node} />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default withStyles(styles)(PostList);
